export class NavigatorUtil {
  static isMobile() {
    try {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      }
    } catch (error) {
      console.log('判斷 isMobile 發生錯誤 ' + error);
    }

    return false;
  }

  static isTablet() {
    let size = Math.min(screen.width, screen.height);
    return size >= 768 && size < 992;
  };

  static isWebView() {
    let inAppDetector = new InAppDetector(navigator.userAgent || navigator.vender || window.opera);
    return inAppDetector.isInApp();
  }

  static isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  static isIos() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  static isTWID() {
    return navigator.userAgent.includes('TWID');
  }

  static isMacOS() {
    return /.*mac.*/.test(navigator.platform.toLowerCase());
  }

  static isWifiConnect() {
    let cellularConnects = ['wifi'];
    let currentConnect = NavigatorUtil._getConnection();

    return cellularConnects.includes(currentConnect);
  }

  static isCellularConnect() {
    let cellularConnects = ['4g', '5g', 'cellular'];
    let currentConnect = NavigatorUtil._getConnection();

    return cellularConnects.includes(currentConnect);
  };

  static getDeviceID(webcom, userId) {
    let deviceId = '';

    twcaLib.QueryDeviceID(webcom, userId, function (resultCode, msg, token, data) {
      if (resultCode === 0) {
        let returnObj = (typeof data === 'string') ? JSON.parse(data) : data;
        deviceId = returnObj['deviceId'];
      }
    });
    return deviceId;
  }

  static getDeviceType() {
    if (navigator.platform.indexOf('Win') > -1) {
      // Microsoft Windows
      return 'HW';
    } else if (navigator.platform.indexOf('Mac') > -1) {
      // Apple macOS
      return 'HM';
    } else if (navigator.userAgent.match(/iPhone/i)) {
      // Apple iPhone
      return 'HI';
    } else if (navigator.userAgent.match(/iPad/i)) {
      // Apple iPad
      return 'HI';
    } else if (navigator.userAgent.match(/Android/i)) {
      // Google Android
      return 'HG';
    } else {
      // other device
      return 'OT';
    }
  }

  static getVenderID() {
    let ua = navigator.userAgent.toLowerCase();
    let inAppDetector = new InAppDetector(ua);

    let sBrowser = '';

    if (ua.includes('twca-webca-webview-macos')) {
      // TWCA macOS application
      sBrowser = 'A';
    } else if (ua.includes('twid')) {
      // TWID APP or TWCA Lib
      sBrowser = 'T';
    } else if (inAppDetector && inAppDetector.isInSpecificApp()) {
      // in app webview
      let appName = inAppDetector.getAppName();
      if (appName === 'messenger' || appName === 'facebook') {
        sBrowser = 'M';
      } else if (appName === 'line') {
        sBrowser = 'L';
      } else {
        sBrowser = 'O';
      }
    } else if (ua.includes('edg')) {
      sBrowser = 'E';
    } else if (ua.includes('firefox')) {
      sBrowser = 'F';
    } else if (ua.includes('msie')) {
      sBrowser = 'I';
    } else if (ua.includes('rv:11.0') && ua.includes('like gecko')) {
      if (ua.includes('windows nt 6.3;')) {
        sBrowser = 'I';
      } else {
        if (ua.includes('windows nt')) {
          sBrowser = 'I';
        } else {
          sBrowser = 'O';
        }
      }
    } else if (ua.includes('iemobile')) {
      sBrowser = 'I';
    } else if (ua.includes('chrome')) {
      sBrowser = 'C';
    } else if (ua.includes('safari')) {
      if (ua.includes('gsa') || ua.includes('crios')) {
        sBrowser = 'C';
      } else {
        sBrowser = 'S';
      }
    } else if (ua.includes('dophin')) {
      sBrowser = 'O';
    } else if (ua.includes('opera')) {
      sBrowser = 'O';
    } else {
      sBrowser = 'O';
    }

    return sBrowser;
  }

  static _getConnection() {
    let connection = navigator.connection || navigator.webkitConnection;
    if (connection) {
      if (connection.type) {
        // 先選擇 type，如果是 wifi 這裡應該就回傳 wifi 了
        return connection.type;
      } else if (connection.effectiveType) {
        // effectiveType 其實就是個判斷網速工具，通常為 4g
        return connection.effectiveType;
      }
    }

    // 啥都看不到就當行動網路吧
    return 'cellular';
  }
}
